import { render, staticRenderFns } from "./ShowroomList.vue?vue&type=template&id=0956bade"
import script from "./ShowroomList.vue?vue&type=script&lang=js"
export * from "./ShowroomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports